import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "antd";
import { I18N_NS } from "Config/i18n";
import { viewsStore } from "Pages/Project/Views/Stores/ViewsStore";
import { WithTranslation, withTranslation } from "react-i18next";
import { documentsTableStore } from "../Stores/DocumentsTableStore";

interface DirectDownloadProps extends WithTranslation {
  fileId: number;
  module: API_PROJECT_STARTWITH;
}

export const DirectDownload = withTranslation(I18N_NS.PROJECT)(({ t, fileId, module }: DirectDownloadProps) => {
  const handleDownload = (module: API_PROJECT_STARTWITH, fileId: number) => {
    if (module === "DOCUMENTS") {
      documentsTableStore.downloadFiles([fileId]);
    } else if (module === "VIEW") {
      viewsStore.downloadFiles([fileId]);
    }
  };

  return (
    <Tooltip title={t("Direct download")}>
      <span
        className="direct-download"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleDownload(module, fileId);
        }}
      >
        <FontAwesomeIcon icon={["far", "download"]} fixedWidth={true} />
      </span>
    </Tooltip>
  );
});
